import { Box, useTheme, Button, TextField } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { motion } from "framer-motion";
import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserAuth } from "../context/AuthContext";
import Header from "./Header";
import TokenContext from "../context/TokenContext";
import { miLegajo } from "../Redux/legajo";
import TablaFormacionDocente from "./tablas/TablaFormacionDocente";
import { COLUMNSFORMACION } from "../columnas/columnaFormacion";
import ModalSolicitudEducacion from "./modales/ModalSolicitudEducacion";
import { actualizarTituloMaximo, formaciones } from "../Redux/formacion";
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';


const Formacion = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const token = useContext(TokenContext);
    const { empleado } = UserAuth();

    const legajoSelector = useSelector(store => store.legajo.legajo)
    const [educacionFormal, setEducacionFormal] = React.useState([])
    const eduFormalSelector = useSelector(store => store.formacion.formacion)
    const [nivel, setNivel] = React.useState([])
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [openEducacion, setOpenEducacion] = React.useState(false)
    const handleOpenEducacion = () => setOpenEducacion(true)
    const handleCloseEducacion = () => setOpenEducacion(false)

    React.useEffect(() => {
        if (token, empleado) {
            dispatch(miLegajo(token, empleado.empleadoid))
            dispatch(formaciones(token, empleado.usuarioPortalRh))
        }
    }, [token, empleado]);

    React.useEffect(() => {
        if (legajoSelector.length > 0) {
            const item = {
                value: legajoSelector[0].new_nivel,
                label: legajoSelector[0]["new_nivel@OData.Community.Display.V1.FormattedValue"]
            };
            setNivel(item.value);
        }
    }, [legajoSelector])

    React.useEffect(() => {
        if (eduFormalSelector?.length > 0) {
            var array = []
            eduFormalSelector.forEach(element => {
                var objeto = {
                    id: element.new_universidadporcontactoid,
                    new_fechaegreso: element["new_fechaegreso@OData.Community.Display.V1.FormattedValue"],
                    new_name: element.new_name,
                    new_titulo: element.new_titulo,
                    new_validado: element.new_validado,
                    _new_universidad_value: element["_new_universidad_value@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setEducacionFormal(array)
        }
    }, [eduFormalSelector])

    const handleSubmit = () => {
            dispatch(actualizarTituloMaximo(token,nivel, empleado.empleadoid ))
                .then((id) => {
                    dispatch(miLegajo(token, empleado.empleadoid))
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
    };

    const opcionesNivel = [
        { value: "", label: "Seleccione una opción" },
        { value: 100000000, label: "Grado" },
        { value: 100000001, label: "Especialización" },
        { value: 100000002, label: "Maestría" },
        { value: 100000003, label: "Doctorado" },
        { value: 100000004, label: "Secundario" },
    ]

    return (
        <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
        >
            <Box m="1.5rem 2.5rem">
                <Header
                    title={"Formación"}
                />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={10} sx={{ mt: 2 }}>
                        <FormControl fullWidth>
                            <InputLabel id="select-label">Título Máximo Obtenido</InputLabel>
                            <Select
                                color="secondary"
                                labelId="select-label"
                                value={nivel}
                                onChange={event => setNivel(event.target.value)}
                            >
                                {opcionesNivel.map(option => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                    </Grid>
                    <Grid item xs={12} sm={2} sx={{ mt: 2 }}>
                        <Button onClick={handleSubmit} color="secondary" variant="contained">Actualizar Título Máximo </Button>
                    </Grid>
                    <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                        <TablaFormacionDocente columnas={COLUMNSFORMACION} lineas={educacionFormal} handleOpen={handleOpenEducacion} />
                    </Grid>
                </Grid>
            </Box>
            <ModalSolicitudEducacion open={openEducacion} handleClose={handleCloseEducacion} />
        </motion.div>
    )
}

export default Formacion